import React from 'react';
import {
  Box,
  Grid,
  CircularProgress,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { ContextPanel } from '../../../components/ContextPanel';
import { MDTypography } from '../../../components/MDTypography';
import useTaskDetail from '../../../hooks/useTaskDetail';
import TaskSidePanel from './TaskSidePanel';
import TaskFeed from './TaskFeed';
import { useAuthContext } from 'contexts/authContext';
import { TaskDetail } from 'types/interfaces/task.types';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    height: '100%',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  headerTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));

interface TaskDetailsPanelProps {
  taskId: string | null;
  open: boolean;
  onClose: () => void;
  onTaskUpdated: () => void;
  onTaskDeleted: (task: TaskDetail) => void;
}

const TaskDetailsPanel: React.FC<TaskDetailsPanelProps> = ({
  taskId,
  open,
  onClose,
  onTaskUpdated,
  onTaskDeleted,
}) => {
  const classes = useStyles();
  const { task, loading, updateTask, addComment } = useTaskDetail(taskId || undefined);
  const { user } = useAuthContext();

  if (loading && open) {
    return (
      <ContextPanel open={open} onClose={onClose} title="Loading..." size="large">
        <Box className={classes.loadingContainer}>
          <CircularProgress />
        </Box>
      </ContextPanel>
    );
  }

  if (!task) return null;

  const headerTitle = (
    <Box className={classes.headerTitle}>
      <AssignmentIcon color="primary" />
      <MDTypography variant="h6" fontWeight="medium">
        {task.title}
      </MDTypography>
    </Box>
  );

  return (
    <ContextPanel
      open={open}
      onClose={onClose}
      title={headerTitle}
      size="large"
    >
      <Grid container className={classes.container}>
        {/* Left Panel - Details (30%) */}
        <Grid item xs={12} md={4}>
          <TaskSidePanel 
            task={task} 
            updateTask={updateTask} 
            onTaskUpdated={onTaskUpdated}
            onTaskDeleted={onTaskDeleted}
          />
        </Grid>

        {/* Right Panel - Feed (70%) */}
        <Grid item xs={12} md={8}>
          <TaskFeed 
            task={task} 
            currentActor={user?.userActor || 'CARRIER'}
            addComment={addComment} 
          />
        </Grid>
      </Grid>
    </ContextPanel>
  );
};

export default TaskDetailsPanel;
